let socket = null;
const url = process.env.REACT_APP_SOCKET_URL
export function getSocket() {
  if (!socket || socket.readyState === WebSocket.CLOSED) {
    socket = new WebSocket(url);

    socket.onopen = () => {
      console.log("✅ Socket conectado");
    };

    socket.onclose = () => {
      console.log("❌ Socket fechado");
    };
  }

  return socket;
}